import React, { useContext } from 'react';
import { IAppContext, AppContext } from 'appState/appContext';
import { IModifiersContext, ModifiersContext } from '../../modifiersState/modifiersContext';
import { ModifiersByCustomerList } from './ModifiersByCustomerList';
import { ModifiersByRestaurantList } from './ModifiersByRestaurantList';
import { PaginationComponent } from 'components/PaginationComponent/PaginationComponent';
import NoResultsFound from 'components/NoResultsFound/NoResultsFound';
import style from './Modifiers.module.scss';

export const Modifiers: React.FC = () => {
	const { isLoading } = useContext<IAppContext>(AppContext);
	const { changeCurrentPage, modifiersByCustomer, modifiersByRestaurant, currentPage, countOfItems } =
		useContext<IModifiersContext>(ModifiersContext);

	return (
		<>
			{modifiersByCustomer.totalCount || modifiersByRestaurant.totalCount ? (
				<div className={style.container} data-test="Modifiers">
					{!!modifiersByCustomer.totalCount && <ModifiersByCustomerList />}
					{!!modifiersByRestaurant.totalCount && <ModifiersByRestaurantList />}
					<PaginationComponent
						currentPage={currentPage}
						countOfItems={countOfItems}
						entitiesCount={modifiersByCustomer.totalCount || modifiersByRestaurant.totalCount}
						changeCurrentPage={changeCurrentPage}
					/>
				</div>
			) : (
				<NoResultsFound isVisible={!isLoading} />
			)}
		</>
	);
};
